import React from "react";

import { StatsSummaryWithDropdown as StatsSummaryWithDropdownComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const StatsSummaryWithDropdown = () => {
    const {
        statsSummaryWithDropdownData,
        isFetchingStatsSummaryWithDropdown,
        isErrorStatsSummaryWithDropdown,
    } = useSessionDetailsContext();

    const isEmptyState =
        !isErrorStatsSummaryWithDropdown &&
        (!statsSummaryWithDropdownData ||
            statsSummaryWithDropdownData === null ||
            statsSummaryWithDropdownData?.datasets?.length === 0);

    if (isFetchingStatsSummaryWithDropdown) {
        return <ContentLoader height="9.875rem" />;
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:stats-summary-with-dropdown:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                />
            </ComponentWrapper>
        );
    }

    if (isErrorStatsSummaryWithDropdown && !isFetchingStatsSummaryWithDropdown) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                />
            </ComponentWrapper>
        );
    }

    return <StatsSummaryWithDropdownComponent data={statsSummaryWithDropdownData} />;
};

export default StatsSummaryWithDropdown;
